<footer class="footer">
  <nav class="footer__nav">
    <ul>
      <li>
        <a
          [href]="tenantTermsLink"
          target="_blank"
          class="underline"
          data-testid="shared-footer-terms-link"
          >{{ 'footer.termsOfUse' | translate }}</a
        >
      </li>
      <li>
        <a
          [href]="tenantPrivacyLink"
          target="_blank"
          class="underline"
          data-testid="shared-footer-privacy-link"
          >{{ 'footer.privacyPolicy' | translate }}</a
        >
      </li>
      <li>
        <a
          [href]="tenantContactLink"
          class="underline"
          data-testid="shared-footer-contact-link"
          >{{ 'footer.contactUs' | translate }}</a
        >
      </li>
    </ul>
    <p class="footer__copyright">
      &copy; <span class="color-pink">Forta Agility</span>, {{ currentYear }}.
      All rights reserved.
    </p>
  </nav>
</footer>
